import { BlurContext } from '@/context/BlurContext';
import { BlurOptions } from '@/types/blur';
import { useContext } from 'react';

export const useGetBlurStyles = (options?: BlurOptions) => {
  const { color, blurAmount = 10 } = options ?? {};
  const { isBlur } = useContext(BlurContext);

  if (!isBlur) {
    return {};
  }

  return {
    color: 'transparent',
    textShadow: `0 0 ${blurAmount ?? 8}px ${color ?? 'black'}`,
  };
};
